// import '@lottiefiles/lottie-player';
// import { create } from '@lottiefiles/lottie-interactivity';

export default {

    init() {
      console.log('init animation...');
      document.addEventListener("DOMContentLoaded", this.bindEvents);
    },

    bindEvents() {
        const elems = document.querySelectorAll('.lottie-reveal');

        if(!elems.length) {
            return;
        }

        // Services animation
        LottieInteractivity.create({
            player: ".lottie-reveal",
            mode:"scroll",
            actions: [
              {
                visibility: [0.2, 1.0],
                type: "playOnce"
              }
            ]
        });
    },

};